// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


import OptinController from "./optin_controller"
import ManagerController from "./manager_controller"
import FooterController from "./footer_controller"

application.register("optin", OptinController)
application.register("manager", ManagerController)
application.register("footer", FooterController)